export enum ShutterType {
  CadShutter = 'cad-shutter',
  // Others are in reference-data.
}
